"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FeedbackFormControlled = void 0;

var _reactComponents = require("@cimpress/react-components");

var React = _interopRequireWildcard(require("react"));

var _i18n = require("../../locales/i18n");

var _FeedbackQuestion = require("./FeedbackQuestion");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const FeedbackFormControlled = props => {
  const {
    campaign,
    questions,
    responses,
    currentQuestionIndex,
    consentsToFollowup,
    setConsentsToFollowup,
    onChange
  } = props;
  const {
    tt
  } = (0, _i18n.useDoubleTTranslation)();
  const shouldShowFollowupCheckbox = campaign.offerFollowup && currentQuestionIndex === questions.length - 1;

  const handleChange = (questionIndex, response) => {
    if (onChange) {
      const _responses = responses || Array(questions.length);

      const updatedResponses = [..._responses.slice(0, questionIndex), response, ..._responses.slice(questionIndex + 1)];
      onChange(updatedResponses);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_FeedbackQuestion.FeedbackQuestion, {
    language: props.language,
    disabled: props.disabled,
    question: questions[currentQuestionIndex],
    response: (responses || [])[currentQuestionIndex],
    onChange: response => handleChange(currentQuestionIndex, response)
  }), shouldShowFollowupCheckbox ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(_reactComponents.Checkbox, {
    checked: consentsToFollowup,
    label: tt("feedbackForm.consentToFollowup"),
    onChange: e => setConsentsToFollowup(!consentsToFollowup)
  })) : null);
};

exports.FeedbackFormControlled = FeedbackFormControlled;
FeedbackFormControlled.defaultProps = {
  language: 'en'
};